import React from 'react';
import { MdClose, MdAutoAwesome, MdSettings } from 'react-icons/md';

const MentorHeader = ({ onClose, onOpenSettings }) => {
  return (
    <div className="mentorHeader">
      <div className="mentorHeaderTitle">
        <span className="mentorIcon" style={{ display: 'flex', alignItems: 'center' }}><MdAutoAwesome size={22} color="var(--primary)" /></span>
        <h3>AI Mentor</h3>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <button className="btn iconBtn" onClick={onOpenSettings} title="Settings" style={{ background: 'transparent', border: 'none', color: 'var(--text-secondary)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '6px', borderRadius: '50%' }}>
          <MdSettings size={20} />
        </button>
        <button className="btn iconBtn" onClick={onClose} title="Close Mentor" style={{ background: 'transparent', border: 'none', color: 'var(--text-secondary)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '6px', borderRadius: '50%' }}>
          <MdClose size={20} />
        </button>
      </div>
    </div>
  );
};

export default MentorHeader;
